import * as React from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { connect } from "react-redux";
import { changePassword } from '../../app/store/actions/authActions';
import { MainInput, MainPassword } from '../../app/components/Styles';
import { MarketingFormPage, MarketingFormCard, MarketingButton } from '../../app/components/marketing';
import { marketingColors } from '../../app/components/tickitMarketingTheme';

export const ChangePassword = ({ changePassword, isLoading, embedded }) => {
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        changePassword({
            currPassword: data.get('old-password'),
            password: data.get('new-password'),
        });
    };

    const isSuperPlainFields = window.location.pathname === "/Super/ChangePassword";

    const formFields = isSuperPlainFields ? (
        <>
            <MainInput margin="normal" required fullWidth name="old-password" label="Current Password" id="old-password" autoComplete="password" sx={{ my: 1 }} />
            <MainInput margin="normal" required fullWidth name="new-password" label="New Password" id="new-password" sx={{ my: 1 }} />
        </>
    ) : (
        <>
            <MainPassword margin="normal" required fullWidth name="old-password" label="Current Password" id="old-password" autoComplete="current-password" sx={{ my: 1 }} />
            <MainPassword margin="normal" required fullWidth name="new-password" label="New Password" id="new-password" autoComplete="new-password" sx={{ my: 1 }} />
        </>
    );

    const form = (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            {formFields}
            <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                Change password
            </MarketingButton>
        </Box>
    );

    if (isLoading) {
        if (embedded) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress sx={{ color: marketingColors.p700 }} />
                </Box>
            );
        }
        return (
            <MarketingFormPage maxWidth="sm" title="Change password" subtitle="Enter your current password and choose a new one" loading />
        );
    }

    if (embedded) {
        return (
            <MarketingFormCard hideHeader sx={{ boxShadow: 'none', border: 'none' }}>
                <Typography component="h2" variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
                    Change password
                </Typography>
                {form}
            </MarketingFormCard>
        );
    }

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Change password"
            subtitle="Enter your current password and choose a new one"
        >
            {form}
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.auth?.isLoading,
    token: state?.auth?.token,
});

const mapDispatchToProps = { changePassword };

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
